var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "span",
      {
        staticClass: "label",
        class: {
          "label-primary": _vm.minutos <= _vm.valor_1,
          "label-warning":
            _vm.minutos > _vm.valor_1 && _vm.minutos <= _vm.valor_2,
          "label-danger": _vm.minutos > _vm.valor_2,
        },
      },
      [
        _c(
          "i",
          {
            staticClass: "fas ",
            class: {
              "fa-check-circle": _vm.minutos <= _vm.valor_1,
              "fa-exclamation-triangle":
                _vm.minutos > _vm.valor_1 && _vm.minutos <= _vm.valor_2,
              "fa-radiation-alt": _vm.minutos > _vm.valor_2,
            },
          },
          [_vm._v(" " + _vm._s(_vm.time) + " ")]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }